<script lang="ts" setup>
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore from 'swiper';
import 'swiper/css';

const props = defineProps({
  banners: {
    type: Array as PropType<
      Array<{
        id: string;
        image: string;
        category: string;
        title: string;
      }>
    >,
    default: []
  }
});

SwiperCore.use([Autoplay, Pagination]);

const bannerShow = ref(false);
const swiperSlideSelector = ref();
const onSwiper = (data: any) => {
  //存放 swiper
  swiperSlideSelector.value = data;
};

const handleSlidePrev = () => {
  swiperSlideSelector.value.slidePrev();
};
const handleSlideNext = () => {
  swiperSlideSelector.value.slideNext();
};

onMounted(() => {
  bannerShow.value = true;
  console.log(props.banners);
});
</script>

<template>
  <section class="banner" :class="{ show: bannerShow }">
    <swiper :autoplay="{
      delay: 3000000
    }" :slides-per-view="1" :space-between="0" :speed="1000" :loop="true" class="swiper-list" @swiper="onSwiper">
      <swiper-slide v-for="(item, index) in banners" :key="index">
        <NuxtLink class="swiper-list__box" :to="`/hence/article/${item.id}`">
          <figure class="swiper-list__pic">
            <Nimg :src="item.image" />
          </figure>
          <div class="swiper-list__content">
            <div class="swiper-list__category" v-if="item.category">{{ item.category }}</div>
            <div class="swiper-list__title" v-if="item.title">
              {{ item.title }}
            </div>
          </div>
        </NuxtLink>
      </swiper-slide>
    </swiper>
    <div class="arrow brand4-1" v-if="banners.length > 1">
      <div class="arrow__prev" @click="handleSlidePrev">
        <svg-icon name="icon-arrow-right2" />
      </div>
      <div class="arrow__next" @click="handleSlideNext">
        <svg-icon name="icon-arrow-right2" />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.banner {
  position: relative;
  margin-bottom: toRem(84);

  @include max-media(990) {
    margin-left: toRem(-24);
    margin-right: toRem(-24);
  }

  &.show {
    .swiper-list {
      &__pic {
        img {
          opacity: 1;
          transition-delay: 0.2s;
        }
      }

      &__category,
      &__title {
        opacity: 1;
        transform: translateY(0);
      }

      &__category {
        transition-delay: 0.3s;
      }

      &__title {
        transition-delay: 0.4s;
      }
    }

    .arrow {
      opacity: 1;
      transform: translateY(0);
      transition-delay: 0.5s;
    }
  }

  .swiper-list {
    &__box {
      position: relative;
      display: block;
    }

    &__pic {
      background-color: $color-white-1;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 80vh;

      @include max-media(990) {
        height: 40vh;
        overflow: hidden;
      }

      img {
        display: block;
        width: 100%;
        opacity: 0;
        transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);
      }
    }

    &__content {
      width: 100%;
      max-width: toRem(660);

      @include min-media(991) {
        position: absolute;
        left: toRem(24);
        bottom: toRem(24);
      }

      @include max-media(990) {
        max-width: 100%;
        padding-left: toRem(24);
        padding-right: toRem(24);
        padding-top: toRem(24);
      }
    }

    &__category {
      display: inline-block;
      padding: toRem(8) toRem(24);
      background-color: $color-brand-4_1;
      font-size: toRem(16);
      font-weight: 700;
      color: $color-white-1;
      opacity: 0;
      transform: translateY(12px);
      transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);

      @include max-media(767) {
        padding: toRem(4) toRem(12);
        font-size: toRem(12);
      }
    }

    &__title {
      padding: toRem(9) toRem(24);
      font-size: toRem(28);
      font-weight: 500;
      line-height: 1.52;
      color: $color-white-1;
      border: 1px solid $color-white-1;
      @include dot-many-line(3);
      opacity: 0;
      transform: translateY(12px);
      transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);

      @include max-media(990) {
        border-color: $color-gray-line;
        padding: toRem(12);
        font-size: toRem(16);
        color: $color-black-1;
      }
    }
  }

  .arrow {
    opacity: 0;
    transform: translateY(12px);
    transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);

    @include min-media(991) {
      position: absolute;
      right: toRem(24);
      bottom: toRem(24);
      z-index: 10;
    }

    @include max-media(990) {
      padding-right: toRem(24);
    }

    &__prev {
      margin-right: toRem(48);

      @include max-media(990) {
        margin-right: toRem(12);
      }
    }
  }
}
</style>
